/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Resolve which of the given profiles already sit in a job's pipeline.
 *
 * Powers the talent-search "Add to a position" enrollment pre-step: it lets
 * the client tell how many of the picked profiles still need adding versus how
 * many are already candidates (so it can show "X of Y" and enroll everyone in
 * one pass without re-adding the duplicates).
 */
export interface ResolveCandidatesRequest {
  /**
     * @minItems 1
     * @maxItems 50
     */
  profile_ids: string[];
}
